import { Matrix4, Vector2 } from '@math.gl/core'

type UniformType = 'matrix4' | 'float' | 'integer' | 'vec2'

class Uniform {
    private gl: WebGLRenderingContext
    private location: WebGLUniformLocation | null
    private type: UniformType

    constructor(gl: WebGLRenderingContext, program: WebGLProgram, name: string, type: UniformType) {
        this.gl = gl
        this.location = gl.getUniformLocation(program, name)
        this.type = type
    }

    upload(value: Matrix4 | Vector2 | number) {
        const { gl } = this

        switch (this.type) {
            case 'integer':
                gl.uniform1i(this.location, value as number)
                break
            case 'matrix4':
                gl.uniformMatrix4fv(this.location, false, value as Matrix4)
                break
            case 'vec2':
                gl.uniform2fv(this.location, value as Vector2)
                break
            default:
                gl.uniform1f(this.location, value as number)
                break
        }
    }
}

export default Uniform
